"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsavedChangesModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var HomeUtils_1 = require("../HomeUtils");
var components_1 = require("@athena-portal/components");
var UnsavedChangesModal = /** @class */ (function (_super) {
    __extends(UnsavedChangesModal, _super);
    function UnsavedChangesModal(props) {
        var _this = _super.call(this, props) || this;
        _this.homeUtils = new HomeUtils_1.HomeUtils();
        _this.cancelMTAChanges = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["showUnsavedChangesModal"] = false, _a));
            if (_this.props.interaction.uistate.showUnsavedChangesModal) {
                _this.props.onStateChange("uistate.showUnsavedChangesModal", false);
            }
            _this.executeEvent("change");
        };
        _this.closeModal = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["showUnsavedChangesModal"] = false, _a));
            if (_this.props.interaction.uistate.showUnsavedChangesModal) {
                _this.props.onStateChange("uistate.showUnsavedChangesModal", false);
            }
        };
        _this.state = {
            oldInteraction: {},
            dataLoaded: false
        };
        return _this;
    }
    UnsavedChangesModal.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.interaction.process === services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
            this.customerPortalService.getRenewalProposal(this.props.engine.getInteraction().agreementNumber).subscribe(function (renewalProposal) {
                if (renewalProposal) {
                    _this.setState({
                        oldInteraction: renewalProposal,
                        dataLoaded: true
                    });
                }
            });
        }
        else {
            this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
                _this.setState({
                    oldInteraction: policy.interaction,
                    dataLoaded: true
                });
            });
        }
    };
    UnsavedChangesModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.closeModal });
        var journeyState = this.props.engine.getJourneyState();
        var showModal = journeyState["showUnsavedChangesModal"] || this.props.interaction.uistate.showUnsavedChangesModal;
        if (this.state.dataLoaded && this.props.interaction) {
            return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "unsaved-changes-modal", isOpen: showModal, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { className: "padding-top-32", close: closeBtn, children: "You didn\u2019t save your changes" }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { children: [(0, jsx_runtime_1.jsx)("h3", { className: "font-weight-bold", children: "Do you want to continue with the changes you have made to your policy?" }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: this.homeUtils.getChangesMade(this.props.interaction, this.state.oldInteraction) })] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white btn-next w-100", onClick: this.cancelMTAChanges, children: "Cancel changes" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary w-100", onClick: this.closeModal, children: "Continue with changes" })] })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    ;
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], UnsavedChangesModal.prototype, "customerPortalService", void 0);
    return UnsavedChangesModal;
}(plugin_journey_1.WidgetBase));
exports.UnsavedChangesModal = UnsavedChangesModal;
//# sourceMappingURL=UnsavedChangesModal.js.map